import { render } from "./NotAuthorized.vue?vue&type=template&id=275b6f77&scoped=true"
import script from "./NotAuthorized.vue?vue&type=script&lang=js"
export * from "./NotAuthorized.vue?vue&type=script&lang=js"

import "./NotAuthorized.vue?vue&type=style&index=0&id=275b6f77&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-275b6f77"

export default script